import Vue from "Vue";
import { NotificationServiceInstance } from "../../../services/notification.service";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Notification } from "../../../models/notification";

@Component
export default class NotificationList extends Vue {
	@Prop({ default: "static" })
	public type;

	public listNotification: Notification[] = [];

	public flagList = false;
	public stopTimer = false;

	public mounted(): void {
		this.syncList();
	}

	@Watch("listNotification")
	public listenChange(): void {
		this.flagList = !this.flagList;
		this.$emit("refreshNotif");
	}

	public deleteNotification(idNotif: number): void {
		let getIndex = 0;
		this.listNotification.forEach((notif, index) => {
			if (notif.id === idNotif) {
				getIndex = index;
			}
		});
		this.listNotification.splice(getIndex, 1);
	}

	private syncList(): void {
		this.listNotification = NotificationServiceInstance.listNotification;
	}

	public listenStopTimer(state: boolean): void {
		this.stopTimer = state;
	}
}




// WEBPACK FOOTER //
// ./src/shared/components/notification/notification-list/notification-list.ts